import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const CcoLogo = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 2124.7 897.3" {...props}>
    <path
      d="M1227.4,253.5c-109,0-197.8,88.7-197.8,197.8S1118.4,649,1227.4,649s197.8-88.7,197.8-197.8S1336.5,253.5,1227.4,253.5z
      M1227.3,621.2c-94.5,0-171.1-76.6-171.1-171.1S1132.8,279,1227.3,279s171.1,76.6,171.1,171.1S1321.8,621.2,1227.3,621.2z"
    />
    <path
      d="M1276.5,536.1c3.3,3.3,6.4,6.9,9.2,10.7l1,1.3h46.6c-2.5-5.3-5.5-10.3-9-14.9c-6.5-8.9-14.3-18.9-21.2-26.4l-0.6-0.6
      l0.4-0.7c2.5-4.2,4.7-8.6,6.6-13.1c2-4.8,3.9-9.7,5.5-14.5s3-9.6,4-14.3c0.9-3.9,1.6-7.9,2.1-11.9h-38.5c-0.7,3.7-1.5,7.4-2.6,11.1
      c-1.5,5.5-3.4,10.8-5.6,16l-0.7,1.5l-38.8-37.4l1.3-0.8c10.9-6.3,20.4-14.8,28-24.8c7.3-9.7,11.1-21.5,11-33.6c0-6.5-1.2-13-3.8-19
      c-2.6-5.9-6.4-11.2-11.2-15.4c-5.4-4.7-11.7-8.3-18.6-10.5c-8.4-2.9-17.3-4.3-26.2-4.2c-19.7,0-35.3,5.3-46.5,15.1
      s-16.8,23.9-16.8,42c-0.1,8,2,15.8,6,22.7c4,6.9,8.6,13.5,13.7,19.7l5.5,5.4c-16.3,12-53.1,34.3-32.2,83.1
      c20.5,47.7,82.2,38.5,94.2,34.4c9.5-3.2,23-10.9,36-21.5L1276.5,536.1z M1197.5,372.6c4-4.3,9.7-6.9,16.9-6.9
      c7.9,0,13.6,2.4,17.1,6.5c3.3,3.8,5.2,8.7,5.1,13.7c0,8.7-2.6,15.9-7.8,21.4c-5.3,5.5-11.4,10.2-18.2,13.8l-0.8,0.4l-0.6-0.6
      c-4.9-4.4-9.2-9.5-12.7-15c-3.2-4.9-4.9-10.7-5-16.6C1191.5,382.5,1193.5,376.9,1197.5,372.6z M1227.7,524.4
      c-8,3.2-30.2,6.9-44-11.5s0.4-38,15-47.1l3.8-2.4l47.9,46.6l0.2,0.2C1243.8,516.3,1236.1,521.1,1227.7,524.4L1227.7,524.4z"
    />
    <path
      d="M1481.9,383.8c-17.8,18.3-27.5,42.6-27.3,68.2v0.6c-0.1,12.9,2.3,25.5,7.2,37.6c4.5,11.4,11.4,21.9,19.9,30.6
      c8.7,8.7,19,15.6,30.4,20.4c11.8,5,25,7.6,38.1,7.5l0,0c8.4,0,16.5-0.8,24.6-2.4c13.5-2.7,26.3-8.6,37.1-17.2
      c5.1-4.1,10-8.7,15-13.9c0.1-0.1,0.1-0.4,0-0.5l-26-26.3c-0.2-0.2-0.5-0.1-0.7,0.1c-6.4,6-13.7,11.4-21.8,15.8
      c-7.4,3.9-16.4,5.8-26.8,5.8c-14.7,0.2-28.8-6-38.6-17.2c-4.7-5.4-8.5-11.7-11-18.5c-2.6-7-3.9-14.5-3.9-22.4v-0.5
      c0-7.8,1.3-15.3,4-22.3c2.5-6.8,6.2-13,11.1-18.4c4.9-5.3,10.6-9.5,17-12.4c6.7-3,14.1-4.5,21.4-4.5c8.7-0.1,17.4,1.8,25.1,5.5
      c7.8,3.8,15.3,8.9,22.3,15.2l0.1,0.1c0.1,0.1,0.4,0,0.5-0.1l26-30c0.1-0.2,0.1-0.4,0-0.6c-4.1-4.1-8.7-8-13.9-11.8
      c-5.1-3.6-10.5-6.7-16.2-9c-6.6-2.7-13.2-4.7-19.6-5.9c-8.1-1.5-16.2-2.2-23.8-2.1h-0.1h-0.1c-0.5,0-1,0-1.4,0
      c-13.1,0-25.9,2.6-38.1,7.6C1501,367.8,1490.7,374.8,1481.9,383.8z"
    />
    <path
      d="M1794,502.3c4-9.4,6-19.4,5.9-29.5v-0.4c0.1-10.2-1.9-20.1-5.8-29.6c-3.8-9.1-9.3-17.2-16.2-24c-7-6.8-15.3-12.3-24.6-16.2
      c-10.1-4-20.8-6-31.4-6s-21.3,2-31.4,6c-18.6,7.5-33.2,21.9-41,40.4c-4,9.3-6,19.3-5.9,29.5v0.4c0,10.2,2,20.4,5.8,29.5
      s9.3,17.2,16.2,24c7,6.8,15.3,12.3,24.6,16.2c9.8,4.1,20.3,6.1,31.2,6h0.1c10.4,0.1,21-1.9,31.5-5.8
      C1771.6,535.2,1786.2,520.8,1794,502.3z M1759.1,473.1c0,5.3-0.9,10.3-2.8,15c-1.8,4.5-4.3,8.7-7.7,12.3c-3.3,3.6-7.3,6.5-11.8,8.4
      c-4.8,2-9.9,3-15.1,3c-0.3,0-0.5,0-0.8,0c-4.9,0-9.8-1-14.3-3.1c-9-3.9-16.2-11.6-19.8-20.9c-1.8-4.8-2.8-9.9-2.8-15.1v-0.4
      c0-5.3,0.9-10.4,2.8-15.1c1.8-4.7,4.4-8.9,7.7-12.4c3.1-3.5,7.2-6.4,11.7-8.3c4.8-2.1,9.9-3.1,15.2-3c5.1,0,10.3,1.1,15,3.3
      c8.9,3.8,16.2,11.4,19.8,20.8c1.8,4.8,2.8,9.8,2.8,15.1v0.4H1759.1z"
    />
    <path
      d="M352.2,383.8c-17.8,18.3-27.5,42.6-27.3,68.2v0.6c-0.1,12.9,2.3,25.5,7.2,37.6c4.7,11.6,11.4,21.9,20,30.6
      c8.7,8.7,19,15.6,30.4,20.4c11.9,5,25.1,7.6,38.2,7.5l0,0c8.4,0,16.5-0.8,24.5-2.4c7.2-1.5,14-3.7,20.2-6.7
      c5.9-2.8,11.6-6.4,17-10.5c5.1-4.1,10-8.6,15-13.9c0.1-0.1,0.2-0.4,0-0.5l-26-26.3c-0.1-0.1-0.3-0.1-0.6,0.1
      c-6.4,6-13.7,11.4-21.8,15.8c-7.5,3.9-16.6,5.8-27.2,5.8c-14.7,0-28.6-6.2-38.2-17.2c-4.7-5.4-8.5-11.7-11-18.5
      c-2.6-7-3.9-14.5-3.9-22.4v-0.5c0-7.8,1.3-15.3,4-22.3c2.5-6.8,6.2-13,11.1-18.4c4.9-5.3,10.6-9.5,17-12.4c6.7-3,14.1-4.6,21.4-4.5
      c8.7-0.2,17.4,1.7,25.1,5.4c8.1,4.1,15.6,9.3,22.2,15.4l0.1,0.1c0.1,0.1,0.4,0.1,0.5-0.1l26-30c0.1-0.1,0.1-0.4,0-0.6
      c-4.1-4.1-8.7-8-13.9-11.8c-5.1-3.6-10.5-6.7-16.2-9c-6.6-2.7-13.2-4.7-19.6-5.9c-8.4-1.5-16.2-2.2-23.9-2.1h-0.1h-0.1
      c-0.5,0-1,0-1.4,0c-13.1,0-25.9,2.6-38.1,7.6C371.3,367.8,361,374.8,352.2,383.8z"
    />
    <path
      d="M519.9,443.1c-4,9.3-6,19.3-5.9,29.5v0.4c0,10.3,2,20.2,5.9,29.6c3.8,9.1,9.3,17.2,16.2,24c7,6.8,15.3,12.3,24.6,16.2
      c9.8,4.1,20.4,6.1,31.2,6l0,0c10.9,0,21.4-2,31.4-6c18.6-7.6,33.2-22,41-40.5c4-9.4,6-19.4,5.9-29.5v-0.4
      c0.1-10.2-1.9-20.1-5.8-29.6c-3.8-9-9.3-17.1-16.2-23.9c-7-6.8-15.3-12.3-24.6-16.2c-10.1-4-20.8-6-31.4-6c-10.6,0-21.3,2-31.4,6
      C542.3,410.1,527.7,424.5,519.9,443.1z M576.8,436.5c4.8-2.1,9.9-3.1,15.2-3c5.2,0,10.3,1.1,15.1,3.3c9,3.8,16.2,11.4,19.8,20.8
      c1.8,4.6,2.8,9.7,2.8,15v0.4c0,5.3-0.9,10.3-2.8,15c-1.8,4.5-4.3,8.7-7.7,12.3c-3.5,3.7-7.5,6.5-11.9,8.4c-4.8,2-9.9,3-15.1,3
      c-0.3,0-0.5,0-0.8,0c-4.9,0-9.8-1-14.3-3.1c-9-3.9-16.2-11.6-19.8-20.9c-1.8-4.8-2.8-9.8-2.8-15.1v-0.4c0-5.3,0.9-10.4,2.8-15.1
      c1.8-4.7,4.4-8.9,7.7-12.4C568.3,441.3,572.3,438.4,576.8,436.5z"
    />
    <path
      d="M737.7,399.1h-40.9c-0.2,0-0.4,0.2-0.4,0.4v145.6c0,0.2,0.2,0.4,0.4,0.4h40.8c0.3,0,0.4-0.2,0.4-0.2l0.1-0.1V545V399.5
      C738.1,399.3,737.9,399.1,737.7,399.1z"
    />
    <path
      d="M904.8,545.4h41.4c0.3,0,0.5-0.3,0.5-0.5v-93.5h50.7c0.2,0,0.4-0.2,0.4-0.4v-34.4c0-0.2-0.2-0.4-0.4-0.4h-50.7v-23.5
      c0-4,0.4-7.5,1.2-10.8c0.7-3.1,2.2-6.1,4.1-8.4l0.1-0.1c2.1-2.5,4.8-4.4,7.9-5.5c5.9-2.4,14.6-2.7,24.4-0.8c4.1,0.8,8.1,2,11.8,3.6
      c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.4-0.4l8.1-33.1c0-0.2-0.1-0.4-0.2-0.4c-4.8-1.9-9.9-3.4-15.1-4.6
      c-7.2-1.7-14.5-2.5-21.5-2.4c-21.1,0-37.1,5.6-47.8,16.8c-10.7,11.1-16.1,26.4-16.1,45.3v24.2H823v-23.5c0-4,0.4-7.5,1.2-10.8
      c0.7-3.1,2.2-6.1,4.1-8.4l0.1-0.1c2.1-2.5,4.8-4.4,7.9-5.5c5.9-2.4,14.6-2.7,24.4-0.8c4.1,0.8,8.1,2,11.8,3.6c0.1,0,0.2,0.1,0.3,0.1
      c0.2,0,0.4-0.1,0.4-0.4l8.1-33.1c0-0.2-0.1-0.4-0.2-0.4c-4.8-1.9-9.9-3.4-15.1-4.6c-7.3-1.7-14.4-2.5-21.5-2.4
      c-21.1,0-37.1,5.6-47.8,16.8c-10.7,11.1-16.1,26.4-16.1,45.3v153c0,0.2,0.2,0.4,0.4,0.4h41.4c0.2,0,0.4-0.2,0.4-0.4v-93.6h81.4V545
      C904.4,545.2,904.6,545.4,904.8,545.4z"
    />
    <path
      d="M733.1,337c-2-1.9-4.3-3.4-6.8-4.5c-5.6-2.2-11.7-2.2-17.3,0c-5.1,2.1-9.2,6.1-11.3,11.2c-1.1,2.6-1.6,5.4-1.6,8.1v0.1
      c0,2.8,0.5,5.6,1.6,8.1c1,2.5,2.5,4.8,4.4,6.6c2,1.9,4.3,3.4,6.8,4.5c5.6,2.2,11.8,2.2,17.3,0c5.1-2.1,9.2-6.1,11.3-11.2
      c1.1-2.6,1.7-5.4,1.6-8.1v-0.1c0-2.8-0.5-5.6-1.6-8.1C736.5,341.2,735,338.9,733.1,337z"
    />
  </SvgIcon>
));

export default React.memo(CcoLogo);
